import dayjs from 'dayjs'

//
// 2021-01のような文字列を解析して、timeframe,format,dateを返す関数
// 具体的に期待している文字列は、実装参照
//
type Rule = {
  regexp: RegExp
  timeframe: 'year' | 'fiscal_quarter' | 'month' | 'week' | 'day'
  dayjsFormat?: string
}
const rules: Rule[] = [
  {
    regexp: /^\d\d\d\d$/,
    timeframe: 'year' as const,
    dayjsFormat: `YYYY`,
  },
  {
    regexp: /^\d\d\d\d-\dQ$/,
    timeframe: 'fiscal_quarter' as const,
    // TODO: dayjsでquarterのformatはない？
  },
  {
    regexp: /^\d\d\d\d-\d\d$/,
    timeframe: 'month' as const,
    dayjsFormat: `YYYY-MM`,
  },
  {
    regexp: /^\d\d\d\d-\d\d-\d\dW$/,
    timeframe: 'week' as const,
    dayjsFormat: `YYYY-MM-DD[W]`,
  },
  {
    regexp: /^\d\d\d\d-\d\d-\d\d$/,
    timeframe: 'day' as const,
    dayjsFormat: `YYYY-MM-DD`,
  },
  {
    regexp: /^\d\d\d\d\/\d\d$/,
    timeframe: 'month' as const,
    dayjsFormat: `YYYY/MM`,
  },
  {
    regexp: /^\d\d\d\d\/\d\d\/\d\d$/,
    timeframe: 'day' as const,
    dayjsFormat: `YYYY/MM/DD`,
  },
  {
    regexp: /^\d\d\d\d\d\d$/,
    timeframe: 'month' as const,
    dayjsFormat: `YYYYMM`,
  },
  {
    regexp: /^\d\d\d\d\d\d\d\d$/,
    timeframe: 'day' as const,
    dayjsFormat: `YYYYMMDD`,
  },
  {
    regexp: /^\d\d\d\d\/\d?\d$/,
    timeframe: 'month' as const,
    dayjsFormat: `YYYY/M`,
  },
  {
    regexp: /^\d\d\d\d\/\d?\d\/\d?\d$/,
    timeframe: 'day' as const,
    dayjsFormat: `YYYY/M/D`,
  },
  {
    regexp: /^\d\d\d\d\.\d\d\.\d\d$/,
    timeframe: 'day' as const,
    dayjsFormat: `YYYY.MM.DD`,
  },
  {
    regexp: /^\d\d\d\d\.\d?\d\.\d?\d$/,
    timeframe: 'day' as const,
    dayjsFormat: `YYYY.M.D`,
  },
]

export function parseDateFormatString(x: string) {
  const rule = rules.find((r) => r.regexp.test(x))
  if (rule === undefined) {
    return undefined
  }
  return {
    ...rule,
    date: dayjs(x, rule.dayjsFormat),
  }
}
